export default "__VITE_ASSET__DpBRiafz__"